export default {
  'daymonthorweek.month': 'Day(s) of the month',
  'daymonthorweek.week': 'Day(s) of the week'
};
